/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangeRequestAndDraftRequest } from './ChangeRequestAndDraftRequest';
import {
    ChangeRequestAndDraftRequestFromJSON,
    ChangeRequestAndDraftRequestFromJSONTyped,
    ChangeRequestAndDraftRequestToJSON,
    ChangeRequestAndDraftRequestToJSONTyped,
} from './ChangeRequestAndDraftRequest';

/**
 * 
 * @export
 * @interface ChangeRequestCreateOrUpdateRequest
 */
export interface ChangeRequestCreateOrUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestCreateOrUpdateRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestCreateOrUpdateRequest
     */
    storeProfileId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestCreateOrUpdateRequest
     */
    draftId?: string;
    /**
     * 
     * @type {ChangeRequestAndDraftRequest}
     * @memberof ChangeRequestCreateOrUpdateRequest
     */
    store?: ChangeRequestAndDraftRequest;
}

/**
 * Check if a given object implements the ChangeRequestCreateOrUpdateRequest interface.
 */
export function instanceOfChangeRequestCreateOrUpdateRequest(value: object): value is ChangeRequestCreateOrUpdateRequest {
    return true;
}

export function ChangeRequestCreateOrUpdateRequestFromJSON(json: any): ChangeRequestCreateOrUpdateRequest {
    return ChangeRequestCreateOrUpdateRequestFromJSONTyped(json, false);
}

export function ChangeRequestCreateOrUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestCreateOrUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'storeProfileId': json['storeProfileId'] == null ? undefined : json['storeProfileId'],
        'draftId': json['draftId'] == null ? undefined : json['draftId'],
        'store': json['store'] == null ? undefined : ChangeRequestAndDraftRequestFromJSON(json['store']),
    };
}

export function ChangeRequestCreateOrUpdateRequestToJSON(json: any): ChangeRequestCreateOrUpdateRequest {
    return ChangeRequestCreateOrUpdateRequestToJSONTyped(json, false);
}

export function ChangeRequestCreateOrUpdateRequestToJSONTyped(value?: ChangeRequestCreateOrUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'storeProfileId': value['storeProfileId'],
        'draftId': value['draftId'],
        'store': ChangeRequestAndDraftRequestToJSON(value['store']),
    };
}

